'use client';

import React, { MutableRefObject, useEffect } from 'react';

import { clsx } from 'clsx';

import { useAccordion } from '@shared/ui/Accordion/Accordion';

import cls from './AccordionContent.module.scss';

type AccordionContentProps = {
  children: React.ReactNode;
  className?: string;
};

export const AccordionContent: React.FC<AccordionContentProps> = ({ children, className }) => {
  const ref = React.useRef() as MutableRefObject<HTMLDivElement>;
  const { isOpening } = useAccordion();

  useEffect(() => {
    if (isOpening) {
      ref.current.style.maxHeight = ref.current.scrollHeight + 'px';
    } else {
      ref.current.style.maxHeight = '0';
    }
  }, [isOpening]);

  const mods: Record<string, string | boolean | undefined> = {
    [cls.open]: isOpening
  };

  return (
    <div
      ref={ref}
      className={clsx(cls.wrap, className, mods)}
    >
      {children}
    </div>
  );
};
